import React from 'react';
import BotKnowledgePanel from '../components/BotKnowledgePanel';

// Página dedicada del Asistente IA (módulo propio en el menú admin).
export default function BotPage() {
  return (
    <div className="page">
      <div className="page-header" style={{ marginBottom: 8 }}>
        <div>
          <h1 className="page-title">Asistente IA</h1>
          <p className="page-subtitle" style={{ color: 'var(--text-muted, #889)', fontSize: 14, marginTop: 2 }}>
            Cargá los documentos que el bot usa para responder a clientes en la web y WhatsApp.
          </p>
        </div>
      </div>
      <BotKnowledgePanel />
    </div>
  );
}
